module.exports = __webpack_public_path__ + "img/ios-walk.9dc33df5.svg";